import type { HelpFile } from '../../types/help'
import { RoleDetailTestIds } from '../../../testids/RoleDetailTestIds'

export const roleDetailHelp: HelpFile = {
  docPage: '/docs/authorization/roles',
  texts: {
    [RoleDetailTestIds.roleDetailPage]: 'Detailansicht einer Rolle — gewährte Berechtigungen und abgedeckte Ressourcen dieser Anwendung.',
    [RoleDetailTestIds.btnEditRole]: null,
    [RoleDetailTestIds.btnDeleteRole]: 'Diese Rolle löschen — Mitglieder verlieren ihre Berechtigungen sofort, die Aktion ist nicht umkehrbar.',
    [RoleDetailTestIds.btnEditPermissions]: 'Berechtigungsmatrix in den Bearbeitungsmodus schalten.',
    [RoleDetailTestIds.btnSavePermissions]: null,
    [RoleDetailTestIds.btnCancelEditPermissions]: 'Offene Berechtigungsänderungen verwerfen und Bearbeitungsmodus verlassen.',
    [RoleDetailTestIds.cardTitlePermissions]: 'Ressourcen und Aktionen, die diese Rolle gewährt — jede Zelle zum Erlauben oder Verweigern umschalten.',
    [RoleDetailTestIds.colResource]: 'Ressourcentyp, auf den sich die Zeilenberechtigungen beziehen.',
    [RoleDetailTestIds.inputFilterPermissions]: 'Matrix nach Ressourcen- oder Aktionsname filtern.',
    [RoleDetailTestIds.roleMetaCard]: 'Identität dieser Rolle — der OAuth-Claim-Schlüssel und die menschenlesbare Beschreibung.',
    [RoleDetailTestIds.roleKeyValue]: 'Stabiler Kebab-Case-Schlüssel, der vorgelagerte OIDC-Rollen-Claims auf diese Rolle abbildet. Nach dem Anlegen schreibgeschützt.',
    [RoleDetailTestIds.roleDescriptionValue]: 'Menschenlesbare Zusammenfassung, was diese Rolle abdeckt.',
  },
}
